import React, { useState } from "react";
import "./TabNavigation.scss";

const TabNavigation = ({ children,tabs }) => {
    const [activeTab, setActiveTab] = useState(0);

    // const tabs = ["Tab 1", "Tab 2", "Tab 3"];

    return (
        <div className="tab-navigation">
            <div className="tabs">
                {tabs?.map((tab, index) => (
                    <div
                        key={index}
                        className={`tab ${index === activeTab ? "active" : ""}`}
                        onClick={() => setActiveTab(index)}
                    >
                        {tab?.tab_title}
                    </div>
                ))}
            </div>
            <div className="underline">
                <div
                    className="indicator"
                    style={{
                        width: `${100 / tabs?.length}%`,
                        transform: `translateX(${activeTab * 100}%)`,
                    }}
                />
            </div>
            {/* Render the content for the active tab */}
            <div className="tab-content">
                {React.Children.toArray(children)[activeTab]}
            </div>
        </div>
    );
};

export default TabNavigation;